import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const AVAILABLE_BOOKINGS = [
  {
    apiParam: 'webinar',
    id: 'WBR-65c2c3a6273948c8bcef6acc6a5cc420',
    createdBy: 'NitgsuTQJ2QJ4Kkn1DZIBxsNlRh1',
    enabled: true,
    deleted: false,
    idByUser: false,
    slug: 'shourya-webinar',
    createdTime: '2024-01-10 07:18:42',
    modifiedTime: '2024-01-10 14:47:23',
    modifiedBy: 'NitgsuTQJ2QJ4Kkn1DZIBxsNlRh1',
    title: 'Digital Burnout Management',
    description:
      "Learn to navigate digital burnout with this practical guide. Whether you're a professional or student, find strategies to balance technology and well-being in today's fast-paced world.",
    altTexts: {},
    durationInMins: 20,
    preBufferMins: 0,
    postBufferMins: 0,
    type: 'webinar',
    free: true,
    publicEvent: true,
    meetingSrc: 'aumhum',
    minUsers: 1,
    maxUsers: 30,
    location: {
      city: 'Delhi',
      country: 'India',
      countryCode: 'in',
      address: 'Talkatora Stadium, Najafgarh East, East of Kailash\nKarkardooma',
    },
    mentorId: 'TCH-ddb757179d174739a46133ac7db0c4f8',
    mentorSlug: 'somya',
    mentorName: 'Somya Singh',
    startTime: '2024-05-15T17:00:00.000Z',
    endTime: '2024-05-15T18:00:00.000Z',
  },
  {
    id: 'EVT-f383f8b3b96e41eeb692b674cfdbe41a',
    title: 'Webinar Session: Calm in Chaos',
    // description:
    //   'Morbi sit amet magna quis dolor feugiat eleifend. Quisque erat sapien, fermentum et lorem ut, molestie fermentum ligula. Nunc in lorem at arcu accumsan bibendum rhoncus a dui. Ut sodales vel ligula quis bibendum. Fusce sollicitudin auctor vulputate. Nunc ut lobortis ante, vel malesuada orci. Praesent venenatis dolor in nisi laoreet vestibulum. Mauris ultricies dapibus tellus, a mattis mi imperdiet sit amet.',
    description: '',
    startTime: '2024-05-16T17:00:00.000Z',
    endTime: '2024-05-16T18:00:00.000Z',
    type: 'webinar',
    subscriptionPlanId: 'SPN-ddb1b59129bb40c28d4ccaff131d6416',
    mentorName: 'Somya Singh',
    mentorSlug: 'somya',
    enabled: true,
    minUsers: 10,
    maxUsers: 100,
  },
  {
    apiParam: 'webinar',
    id: 'WEB-3ce3815d694541e2882f12107516d3b2',
    createdBy: 'NitgsuTQJ2QJ4Kkn1DZIBxsNlRh1',
    enabled: true,
    deleted: false,
    idByUser: false,
    slug: 'shourya-s-webinar',
    createdTime: '2024-01-08 06:50:54',
    modifiedTime: '2024-01-11 06:50:24',
    modifiedBy: 'NitgsuTQJ2QJ4Kkn1DZIBxsNlRh1',
    title: 'Webinar Session: Productivity',
    description: 'Learn how to be productive in workplace. Come join',
    coverIcon: 'MEDIA-2a2a9aa2991e48f89387125f009226e4',
    coverImage: 'MEDIA-3ccf24debbfc47efa381051e93d6780b',
    subscriptionPlanId: 'SPN-ddb1b59129bb40c28d4ccaff131d6416',
    mentorName: 'Somya Singh',
    subscription: {
      id: 'SBP-one-on-one-001',
      planGrpId: '1on1',
    },
    altTexts: {},
    durationInMins: 20,
    preBufferMins: 0,
    postBufferMins: 0,
    type: 'webinar',
    free: false,
    publicEvent: true,
    minUsers: 30,
    maxUsers: 100,
    mentorSlug: 'somya',
    mentorId: 'TCH-255a4a579e6a4e07b27a783a17559d21',
  },
]

export const ALREADY_BOOKED = [
  {
    id: 'EVE-15ed1c8f84d64b99a67c392c88dc739a',
    createdBy: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    enabled: true,
    deleted: false,
    idByUser: false,
    apiParam: 'booked-event',
    createdTime: '2024-01-11 05:37:11',
    modifiedTime: '2024-01-11 05:37:11',
    modifiedBy: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    mentorId: 'TCH-255a4a579e6a4e07b27a783a17559d21',
    userId: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    userName: 'Dhawal Sharma',
    startTime: '2024-05-10 11:00:00',
    endTime: '2024-01-10 11:20:00',
    slotStart: '2024-05-10 11:00:00',
    slotEnd: '2024-05-10 11:20:00',
    status: 'booked',
    paymentStatus: 'paid',
    eventType: 'webinar',
    feedbackTaken: false,
    eventTypeId: 'WBR-65c2c3a6273948c8bcef6acc6a5cc420',
    price: 0.0,
    discount: 0.0,
    finalPrice: 0.0,
    feePaid: 0.0,
    meetingSrc: 'aumhum',
    markedCompleted: false,
    appointmentNumber: 'VN108',
    minUsers: 1,
    maxUsers: 1,
    mentorName: 'Sheetal Chaudhary',
    eventName: 'Emotional Regulation Strategies For Effective Communication',
    mentorProfilePic: 'MEDIA-5198b0d874ce4efc8624549345fd9ed7',
    eventDuration: 20,
    eventDescription: 'Shourya Webinar Description (test)',
    title: 'Emotional Regulation Strategies For Effective Communication',
  },
  {
    apiParam: 'webinar',
    id: 'WEB-f858dd52510a44eeb416cd9f36582586',
    enabled: true,
    slug: 'harsh-webinar',
    title: 'Developing Emotional Intelligence For Improved Workplace Relationships',
    startTime: '2024-05-15 14:00:00',
    endTime: '2024-05-02 14:20:00',
    slotStart: '2024-05-02 14:00:00',
    slotEnd: '2024-01-15 14:20:00',
    mentorName: 'Somya Singh',
    type: 'webinar',
    minUsers: 5,
    maxUsers: 120,
  },
  {
    id: 'EVE-15ed1c8f84d64b99a67c392c88dc739a',
    createdBy: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    enabled: true,
    deleted: false,
    idByUser: false,
    apiParam: 'booked-event',
    createdTime: '2024-01-11 05:37:11',
    modifiedTime: '2024-01-11 05:37:11',
    modifiedBy: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    mentorId: 'TCH-255a4a579e6a4e07b27a783a17559d21',
    userId: 'USR-d1ebd7aff0c948a8985114bee64f49d9',
    userName: 'Dhawal Sharma',
    startTime: '2024-05-04 17:00:00',
    endTime: '2024-01-15 17:20:00',
    slotStart: '2024-05-04 17:00:00',
    slotEnd: '2024-01-15 17:20:00',
    status: 'booked',
    paymentStatus: 'paid',
    eventType: 'webinar',
    feedbackTaken: false,
    eventTypeId: 'WBR-65c2c3a6273948c8bcef6acc6a5cc420',
    price: 0.0,
    discount: 0.0,
    finalPrice: 0.0,
    feePaid: 0.0,
    meetingSrc: 'aumhum',
    markedCompleted: false,
    appointmentNumber: 'VN108',
    minUsers: 1,
    maxUsers: 1,
    mentorName: 'Somya Singh',
    eventName: 'Managing workload and productivity at Workplace',
    mentorProfilePic: 'MEDIA-5198b0d874ce4efc8624549345fd9ed7',
    eventDuration: 20,
    eventDescription: 'Shourya Webinar Description (test)',
    title: 'Managing workload and productivity at Workplace',
  },
]

export async function fetchAvalableBookings() {
  const resp = { data: AVAILABLE_BOOKINGS }
  return resp?.data
}

export async function fetchAlreadyBookedWebinars() {
  // const resp = await getBPDataWithoutParams(API_SIGNATURES.getBookings)
  // return resp?.data?.filter((booking) => booking?.eventType === allAvailableEventTypes.webinar)
  return ALREADY_BOOKED
}

export function checkIfTwoDatesAreEqual(d1, d2, timeZone) {
  const timeZoneToUse = timeZone || '+5:30'
  const date1 = dayjs(d1).utcOffset(timeZoneToUse)
  const date2 = dayjs(d2).utcOffset(timeZoneToUse)
  return date1.isSame(date2, 'day') && date1.isSame(date2, 'month') && date1.isSame(date2, 'year')
}

export function checkIfBookingIsAvailable(webinar, currentDate, selectedTimeZone) {
  return checkIfTwoDatesAreEqual(webinar?.startTime, currentDate, selectedTimeZone)
}
